import { render, staticRenderFns } from "./ClientViewSlot.vue?vue&type=template&id=e52b12c4&"
import script from "./ClientViewSlot.vue?vue&type=script&lang=js&"
export * from "./ClientViewSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports